<template>
  <q-page class="flex flex-center">
    <div class="q-card q-pa-xl">
      <h4>Login</h4>
      <LoginForm />
    </div>
  </q-page>
</template>

<script>
import LoginForm from '../components/LoginForm.vue'

export default {
  name: 'LoginPage',
  components: {
    LoginForm
  }
}
</script>
